import { environment } from './../../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DynamicTableFormService {
    private readonly dynamicTableAPI: string;
    constructor(private readonly http: HttpClient) {
        this.dynamicTableAPI = environment.dynamicTableAPI;
    }

    //Dynamic Form
    // GET: Dynamic Form
    getDynamicForm(formId: string): Observable<any> {
        return this.http.get<any>(`${this.dynamicTableAPI}Form/${formId}`);
    }
    // createDynamicForm
    createDynamicForm(dynamicForm: any): Observable<any> {
        return this.http.post<any>(`${this.dynamicTableAPI}Form`, dynamicForm, {});
    }

    // PUT: editDynamicForm
    editDynamicForm(formId: string, modifiedDynamicForm: any): Observable<any> {
        return this.http.put(`${this.dynamicTableAPI}Form/${formId}`, modifiedDynamicForm);
    }

    //deleteDynamicForm 
    deleteDynamicForm(formId: string) {
        return this.http.delete<any>(`${this.dynamicTableAPI}Form/${formId}`);
    }

    //update Form Authentication
    // PUT: editDynamicForm
    updateFormAuthentication(formId: string, modifiedFormAuthentication: any): Observable<any> {
        return this.http.put(`${this.dynamicTableAPI}Form/${formId}/Authentication`, modifiedFormAuthentication);
    }

    validateFormAuthentication(formId: string, authentication: string): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json-patch+json',
            'accept': 'text/plain'
        });

        const body = JSON.stringify(authentication);

        return this.http.post<any>(`${this.dynamicTableAPI}Form/${formId}/ValidateAuthentication`, body, { headers });
    }

}
